import React from 'react';
import './Page.scss';
import { Helmet } from 'react-helmet';

interface Props {
  children: React.ReactNode;
  windowTitle: string;
}

const Page: React.FC<Props> = ({
  children,
  windowTitle,
}: Props): JSX.Element => (
  <div className="page-wrapper">
    <Helmet>
      <title>{windowTitle}</title>
    </Helmet>
    {children}
  </div>
);

export default Page;
